<template>
    <div class="doc-section">
        <h1>Gestión de usuarios</h1>
        <p>Un usuario es una persona que usa el sistema, el usuario podrá realizar diferentes acciones dependiendo de su
            rol. </p>

            <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <h2>Roles</h2>
        <p>
            Hay dos tipos de roles <strong>Administrador</strong> y <strong>Usuario final</strong>. El rol Administrador
            tiene
            acceso a todas las funciones del sistema.
            El rol Usuario final esta limitado en su totalidad a ver y tener restricciones sobre escritura.
        </p>

        <div v-if="plataforma === 'web'" class="platform-content">
            <h2>Ver usuarios</h2>
            <p>
                Para visualizar la lista de usuarios creados en el sistema, ir al menú y hacer clic sobre la opción
                <strong>Usuarios</strong>. Se mostrará la pantalla principal con el listado de los usuarios registrados.
            </p>


            <h2>Acciones</h2>
            <ol class="ul-contenedor step-list">
                <li>Campo buscar, permite filtrar los elementos de la tabla.</li>
                <li>Botón agregar usuario, permite ir a la vista del mismo nombre para registrar un nuevo usuario.</li>
                <li>Tabla con los usuarios registrados en el sistema, que muestra el nombre de usuario, el rol del
                    usuario y
                    en acciones las opciones de editar ,eliminar, cambiar contraseña y cerrar sesión.</li>
                <li>Paginación permite ver más registros.</li>
            </ol>

            <CarruselAciqui :items="[imagenesUsuarios[0]]" />

            <div class="info-card">
                <strong>Nota:</strong> El administrador podrá visualizar todos los usuarios registrados por los usuarios
                de
                tipo administrador, mientras
                que el usuario final no tiene acceso a esta vista.
            </div>

            <h2>Busqueda de usuarios</h2>
            <p>
                En la vista de usuarios se visualizan todos los usuarios registrados así como un campo
                <strong>“Buscar”</strong>, el cual
                permite un filtrado de datos en la tabla.
            </p>
            <ol class="ul-contenedor step-list">
                <li>Ingresar la palabra o palabras claves para realizar el filtrado.</li>
                <li>El sistema mostrará en la tabla el resultado de la búsqueda como </li>
            </ol>

            <CarruselAciqui :items="[imagenesUsuarios[1]]" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <h2>Ver usuarios</h2>
            <p>
                Para visualizar la lista de usuarios creados en el sistema, ir al menú y hacer clic sobre la opción
                <strong>Usuarios</strong>. Se mostrará la pantalla principal con el listado de los usuarios registrados.
            </p>


            <h2>Acciones</h2>
            <ol class="ul-contenedor step-list">
                <li>Campo buscar, permite filtrar los elementos de la tabla.</li>
                <li>Botón agregar usuario, permite ir a la vista del mismo nombre para registrar un nuevo usuario.</li>
                <li>Tabla con los usuarios registrados en el sistema, que muestra el nombre de usuario, el rol del
                    usuario y
                    en acciones las opciones de editar ,eliminar, cambiar contraseña y cerrar sesión.</li>
            </ol>

            <CarruselAciqui :items="[imagenesUsuariosMoviles[0]]" />

            <div class="info-card">
                <strong>Nota:</strong> El administrador podrá visualizar todos los usuarios registrados por los usuarios
                de
                tipo administrador, mientras
                que el usuario final no tiene acceso a esta vista.
            </div>

            <h2>Busqueda de usuarios</h2>
            <p>
                En la vista de usuarios se visualizan todos los usuarios registrados así como un campo
                <strong>“Buscar”</strong>, el cual
                permite un filtrado de datos en la tabla.
            </p>
            <ol class="ul-contenedor step-list">
                <li>Ingresar la palabra o palabras claves para realizar el filtrado.</li>
                <li>El sistema mostrará en la tabla el resultado de la búsqueda como </li>
            </ol>

            <CarruselAciqui :items="[imagenesUsuariosMoviles[1]]" />
        </div>



    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'GestionUsuario',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesUsuarios: [
            {
                nombre: "Listado de usuarios",
                url: "img/usuarios/listadoUsuarios.png",
                descripcion: "Listado de usuarios registrados en el sistema."
            },
            {
                nombre: "Buscar usuarios",
                url: "img/usuarios/busquedaUsuario.png",
                descripcion: "Busqueda de usuarios"
            }
        ],
        imagenesUsuariosMoviles: [
            {
                nombre: "Listado de usuarios",
                url: "img/usuarios/moviles/listadoUsuarios.png",
                descripcion: "Listado de usuarios registrados en el sistema."
            },
            {
                nombre: "Buscar usuarios",
                url: "img/usuarios/moviles/busquedaUsuario.png",
                descripcion: "Busqueda de usuarios"
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>
